import { render } from "./WatchVidioAdmin.vue?vue&type=template&id=40ecba1d"
import script from "./WatchVidioAdmin.vue?vue&type=script&lang=js"
export * from "./WatchVidioAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__